import {TranslateService} from '@ngx-translate/core';
import {Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ProductTypeEnum} from '@tj/tj-dmp-lib-api';

@Component({
    selector: 'dmp-select-product',
    templateUrl: './select-product.component.html',
    styleUrls: ['./select-product.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectProductComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class SelectProductComponent  implements ControlValueAccessor {
    public options: { label: string; value: string }[] = [];
    @Input() placeholder = '';

    value: string | null = null;

    constructor(private readonly translate: TranslateService) {
        this.options = [
            {label: this.translate.instant('invoicing.common.flights'), value: ProductTypeEnum.FLIGHT},
            {label: this.translate.instant('invoicing.common.hotels'), value: ProductTypeEnum.HOTEL},
            {label: this.translate.instant('invoicing.common.parkings'), value: ProductTypeEnum.PARKING},
            {label: this.translate.instant('invoicing.common.cars'), value: ProductTypeEnum.CAR},
        ];
    }

    onChange: (value: any) => void = () => {};
    onTouched: () => void = () => {};

    writeValue(value: any): void {
        this.value = value;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setValue(value: string) {
        this.value = value;
        this.onChange(value);
        this.onTouched();
    }
}
